@use "sass:color";
@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

$disabled-color: #6a6a6a;
$disabled-background-color: #c0c0c0;

.button {
  font-family: v.$primary-font;
  outline: none;
  padding: 0;
  background-color: transparent;
  appearance: none;
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid transparent;
  @include t.text(14px, 22px, 500);

  &::-moz-focus-inner {
    border: 0;
  }

  &.variant-primary {
    color: var(--tc-on-primary, #{v.$palette-pure-white});
    background-color: var(--tc-btn-primary-bg, #{v.$palette-accent-raw});
    transition-property: background-color;
    transition-duration: v.$transition-duration;

    &:hover {
      background-color: var(--tc-btn-primary-bg-hover, #{color.adjust($color: v.$palette-accent-raw, $lightness: 5%)});
    }

    &:active,
    &:focus {
      background-color: var(--tc-btn-primary-bg-active, #{color.adjust($color: v.$palette-accent-raw, $lightness: -5%)});
    }
  }
  &.variant-secondary {
    background-color: v.$palette-white;
    color: v.$palette-gray-900;
    border-color: v.$palette-gray-300;
    transition-property: color;
    transition-duration: v.$transition-duration;

    &:hover {
      color: v.$palette-accent;
    }
  }
  &.variant-pale {
    background-color: v.$palette-future-accent;
    color: v.$palette-blue;
  }
}

.size-default {
  @include t.text(20px, 30px, 600);
  padding: 4px 16px;
}
.size-tiny {
  @include t.text(14px, 24px, 600);
  padding: 1.5px 12px;
}
.size-small {
  @include t.text(14px, 24px, 600);
  padding: 4px 18px;
}
.size-medium {
  @include t.text(14px, 22px, 600);
  padding: 8px 24px;
}

.button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: v.$palette-white;
  min-height: 29px;
  padding: 0 4px;

  svg path {
    transition-property: fill, stroke;
    transition-duration: v.$transition-duration;
  }

  &:hover {
    &.trash {
      svg path {
        fill: v.$palette-blue;
      }
    }

    &.arrow-right {
      svg path {
        stroke: v.$palette-blue;
      }
    }

    &.link {
      svg path {
        fill: v.$palette-blue;
      }
    }
  }
}

.link {
  display: inline-block;
  text-decoration: none;
}

.button:disabled,
.button:disabled:hover,
.button:disabled:focus,
.button:disabled:active,
.button[disabled],
.button[disabled]:hover,
.button[disabled]:active,
.button[disabled]:focus {
  color: $disabled-color;
  background-color: $disabled-background-color;
  user-select: none;
  cursor: not-allowed;
}

.button-icon:disabled,
.button-icon[disabled],
.button-icon[disabled]:hover {
  &.trash {
    svg path {
      fill: v.$palette-gray-300;
    }
  }
}

.hidden {
  @include c.containerMedia(jsMobile) {
    display: none;
  }
}
